// extracted by mini-css-extract-plugin
module.exports = {"startTime":"video_transcript-module__startTime___2SKC8","selectedRow":"video_transcript-module__selectedRow___SmpPM"};